"use client";

import React from "react";

// material-ui
import { Container, Grid, Typography, Stack } from "@mui/material";

// components
import Image from "@/components/image";

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

// ----------------------------------------------------------------------

export default function LoginLayout({ children }: Props) {
  return (
    <Grid
      container
      sx={{
        height: "100vh",
      }}
    >
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: { xs: "none", md: "block" },
          backgroundImage: `url(${process.env.NEXT_PUBLIC_ASSETS_API}/ui-assets/images/auth/bg-auth.png)`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{ height: "100%", px: { md: 10, lg: 20 }, textAlign: "center" }}
          gap={2}
        >
          <Image
            src={`${process.env.NEXT_PUBLIC_ASSETS_API}/ui-assets/images/auth/image-auth.png`}
            alt="Image Auth"
            width={250}
          />

          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2rem", lg: "2.5rem" },
              fontWeight: 600,
              color: "#fff",
              lineHeight: 1.3,
            }}
          >
            IC-Education
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 400,
              color: "#fff",
              lineHeight: 1.7,
            }}
          >
            Lembaga Pelatihan dan Pendidikan Non Formal dalam bidang keuangan
            dan bisnis.
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={12} md={6}>
        <Container>
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              height: { xs: "90vh", md: "100vh" },
            }}
          >
            {children}
          </Stack>
        </Container>
      </Grid>
    </Grid>
  );
}
